import { render } from "./menuItemSession.vue?vue&type=template&id=7182cccb"
import script from "./menuItemSession.vue?vue&type=script&lang=js"
export * from "./menuItemSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__